import React from 'react';
import { useTranslation } from 'react-i18next';

import MediaTypography from 'components/MediaTypography';

import arrowMobileImage from '@common/assets/images/arrow-mobile.png';
import documentImage from '@common/assets/images/not-found-document.png';
import leafImage from '@common/assets/images/not-found-leaf.png';

import {
	StyledReportEmptyDataArrowImage,
	StyledReportEmptyDataImage,
	StyledReportEmptyDataWrap,
} from './style';

interface PropsType {
	text?: string;
	type: 'leaf' | 'document';
}

function ReportEmptyData({ text, type }: PropsType) {
	const { t } = useTranslation();
	return (
		<StyledReportEmptyDataWrap elevation={2}>
			{type === 'leaf' ? (
				<StyledReportEmptyDataImage src={leafImage} alt="No data image" />
			) : (
				<>
					<StyledReportEmptyDataImage src={documentImage} alt="No data image" />
					<StyledReportEmptyDataArrowImage src={arrowMobileImage} alt="Arrow" />
				</>
			)}

			<MediaTypography variants={{ xs: 'body2' }} variant="body1" sx={{ textWrap: 'balance' }}>
				{text || t('report.achievements.emptyData')}
			</MediaTypography>
		</StyledReportEmptyDataWrap>
	);
}

export default ReportEmptyData;
